import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
  clearReferralAttributionId,
  resolveReferralAttributionIdFromSearch,
  writeReferralAttributionId,
} from '../shared/auth';
import { useEmployeeSession } from '../shared/hooks/use-employee-session';

export function ReferralAttributionRouteObserver() {
  const location = useLocation();
  const { status } = useEmployeeSession();

  useEffect(() => {
    if (status === 'authenticated') {
      clearReferralAttributionId();
      return;
    }

    const referrerId = resolveReferralAttributionIdFromSearch(location.search);

    if (referrerId === undefined) {
      return;
    }

    if (referrerId === null) {
      clearReferralAttributionId();
      return;
    }

    writeReferralAttributionId(referrerId);
  }, [location.search, status]);

  return null;
}
